import {
  WeeklyOrders,
  ApplicantRole,
  TransportType,
  OrderStatus,
  FeeType,
} from "./enums";
import { OrderType } from "./global.interfaces";

export const WeeklyOrdersLabels: Record<WeeklyOrders, string> = {
  [WeeklyOrders.ONE_TO_TEN]: "1-10",
  [WeeklyOrders.ELEVEN_TO_TWENTYFIVE]: "11-25",
  [WeeklyOrders.TWENTY_SIX_TO_FIFTY]: "26-50",
  [WeeklyOrders.FIFTY_ONE_TO_ONEHUNDRED]: "51-100",
  [WeeklyOrders.ONEHUNDRED_ONE_TO_FIVEHUNDRED]: "101-500",
  [WeeklyOrders.OVER_FIVE_HUNDRED]: "500+",
  [WeeklyOrders.UNKNOWN]: "Je ne sais pas",
};

export const ApplicantRoleLabels: Record<ApplicantRole, string> = {
  [ApplicantRole.OWNER]: "Propriétaire du restaurant",
  [ApplicantRole.OPERATIONS_MANAGER]: "Manager des opérations",
  [ApplicantRole.RESTAURANT_MANAGER]: "Manager restaurant",
  [ApplicantRole.ASSISTANT_MANAGER]: "Assistant manager",
  [ApplicantRole.CHEF]: "Chef cuisinier",
};

export const TransportTypeLabels: Record<TransportType, string> = {
  [TransportType.CAR]: "Voiture",
  [TransportType.SCOOTER]: "Moto",
  [TransportType.BIKE]: "Vélo",
};

export const OrderTypeText: Record<OrderType, string> = {
  [OrderType.DELIVERY]: "Livraison",
  [OrderType.PICKUP]: "À emporter",
};

export const OrderStatusText: Partial<Record<OrderStatus, string>> = {
  [OrderStatus.PROCESSING]: "En cours de préparation",
  [OrderStatus.COOKING]: "En préparation",
  [OrderStatus.WAITING_FOR_RIDER]: "En attente du livreur",
  [OrderStatus.DRIVER_ASSIGNED]: "Livreur assigné",
  [OrderStatus.COLLECTED]: "Commande récupérée par le livreur",
  [OrderStatus.WAITING_FOR_PICKUP]: "En attente de récupération",
};

export const FeeTypeText: Record<FeeType, string> = {
  [FeeType.DELIVERY]: "Frais de livraison",
  [FeeType.SMALL_ORDER]: "Frais de petite commande",
  [FeeType.SERVICE]: "Frais de service",
};
